import { useQueryClient } from '@tanstack/react-query';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import DialogCustom from 'commons/DialogCustom';
import API from 'configs/API';
import { axiosPatch } from 'utils/apis/axios';
import { ToastTopHelper } from 'utils/utils';

import CollectionFormBody from '../CollectionFormBody';

const DialogEditCollection = ({ isShowDialog, onCancel, selectedCollection }) => {
  const { t } = useTranslation();
  const [collection, setCollection] = useState(selectedCollection?.name);
  const [isPublic, setIsPublic] = useState(true);
  const queryClient = useQueryClient();

  const handleCancelCollection = () => {
    onCancel();
  };

  const handleCollectionChange = (e) => {
    const value = e.target.value;
    setCollection(value);
  };

  const handleSwitchChange = (e) => {
    const isHidePrice = e.target.checked;
    setIsPublic(isHidePrice);
  };

  const handleSubmitCollection = async () => {
    const { success } = await axiosPatch(API.AUTH.COLLECTION.DETAIL(selectedCollection?.id), {
      name: collection,
      is_public: true,
    });

    if (success) {
      queryClient.invalidateQueries({ queryKey: [API.AUTH.COLLECTION.LIST] });
      handleCancelCollection();
      ToastTopHelper.success(t('edit_success'));
    }
  };
  return (
    <DialogCustom
      isShowDialog={isShowDialog}
      textCancel={t('cancel')}
      dialogTitle={t('edit_publication')}
      textSubmit={t('save')}
      disabledButton={!collection}
      onCancel={handleCancelCollection}
      onSubmit={handleSubmitCollection}
      maxWidth={'md'}
    >
      <CollectionFormBody
        collection={collection}
        onCollectionChange={handleCollectionChange}
        isPublic={isPublic}
        onSwitchChange={handleSwitchChange}
      />
    </DialogCustom>
  );
};

export default DialogEditCollection;
